import type { ExtendedForm } from "@/features/payment-methods/hooks/use-available-payment-methods";

export const getForm = (
  formName: string,
  form?: ExtendedForm
): ExtendedForm | null => {
  if (!form) {
    return null;
  }

  if (formName === form.name) {
    return form;
  }
  const nextForm = form.next;

  if (nextForm) {
    return getForm(formName, nextForm);
  }

  return null;
};
